<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Personal Jewellery Proposal"
			productTypeLabel="Type"
			selectProductInsuranceType="personal_jewellery"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				personal_jewellery: "AegCasePersonalJewellery"
			}
		}
	}
}
</script>
